<template>
    <input
      :type="type"
      :placeholder="placeholder"
      :value="modelValue"
      @input="updateValue"
    />
  </template>
  
  <script>
  export default {
    name: 'InputComponent',  // Utilise un nom de composant multi-mots
    props: {
      modelValue: {  // Liaison avec le parent
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    methods: {
      updateValue(event) {
        this.$emit('update:modelValue', event.target.value);  // Émettre la mise à jour vers le parent
      }
    }
  }
  </script>
  